import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
import {  useHistory } from "react-router-dom";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaTokenExt} from "../funciones/ClienteAxios";
import axios from 'axios';
import moment from 'moment';
export default function MapaLeafDistrito({lista, dtoRegistro, listMapDet }) {
  const mapRef = useRef()
  //const params = useParams()
  let history = useHistory();
  const source = axios.CancelToken.source();
  const [cargando, setCargando] = useState(true)
  const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  const [listPoligono, setListPoligono] = useState([])
  const hoy=moment(new Date()).format('YYYY-MM-DD')      

  useEffect(()=>{         
    
 
   mapRef.current =  leaflet.map('map2').setView([dtoRegistro.DtLat,dtoRegistro.DtLon], 14);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    //const greenIcon = nvoIconLeaflet('/marker-icon-2x-green.png') 
    //const encuestaIcon = nvoIconLeaflet('/marcador.svg') 
    const iconpendiente = nvoIconLeaflet('/marcador-pendiente.svg') 
    const iconRechazo = nvoIconLeaflet('/marcador-rechazado.svg') 
    const iconValido = nvoIconLeaflet('/marcador-valido.svg') 
    if (lista.length!==0 && lista.length!==0  ) {
      const nvoList =lista
      //const centro =[nvoList[0].DtLat, nvoList[0].DtLon]
      ///mapRef.current.setView(centro);
      let arrPoligono=[]
      const filtro = nvoList.filter((poligono)=>poligono.DtId===dtoRegistro.DtId)
  /*     nvoList.forEach((poligono)=>{
        let arrPath=[]
        if (poligono.gps && poligono.DtId===dtoRegistro.DtId) {
          poligono.gps.forEach((paths)=>{
            arrPath.push([paths.Lt,paths.Ln])
          })
        }
        arrPoligono.push(arrPath)
        let marker = leaflet.marker([poligono.DtLat,poligono.DtLon], {icon:greenIcon});    
        const cadena=`${poligono.DtNom}`          
        marker.bindPopup(cadena).openPopup();
        marker.addTo(mapRef.current).on('click', mostrar);
      })   */ 
      //console.log(listMapDet);
      
      if (listMapDet.length!==0 && listMapDet[0].Id!==0 && listMapDet[0].Id!=="0" ) 
      { mapRef.current.setView([listMapDet[0].Lat, listMapDet[0].Lon]);
        listMapDet.forEach((encuesta)=>{
          let marker = leaflet.marker([encuesta.Lat,encuesta.Lon], 
            {icon:encuesta.Percepcion===2 ? iconpendiente:(encuesta.Percepcion===1?  iconValido:iconRechazo)});    
          const fch=moment(encuesta.Fecha).format('DD/MM/YYYY') 
          const cadena=`<p>${fch} ${encuesta.Nombre} ${encuesta.Paterno} ${encuesta.Materno}<br/>Capturista: ${encuesta.UserNom}<br/>${encuesta.BarrNom}</p>`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);
        })
        
      }
      let arrPath=[]
       filtro[0].gps.forEach((paths)=>{
          arrPath.push([paths.Lt,paths.Ln])
        })
      arrPoligono.push(arrPath)
      //let marker = leaflet.marker([dtoRegistro.DtLat,dtoRegistro.DtLon], {icon:greenIcon});    
      //const cadena=`${dtoRegistro.DtNom}`          
      //marker.bindPopup(cadena).openPopup();
      //marker.addTo(mapRef.current).on('click', mostrar);
      const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: dtoRegistro.DtCol });
      polygon.addTo(mapRef.current); 
    }
    
    return () => {
      mapRef.current = null
      source.cancel();
    }

  },[]) 

/*   useEffect(()=>{         
    
    if (listaPromovid && listaPromovid.lenght!== 0 ) {
      listaPromovid.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const promoIcon = nvoIconLeaflet('/marker-icon-2x-green.png')
          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:promoIcon});    
          const cadena=`${poligono.Nom}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);  
        }        
      })         
    }          
    
  },[listaPromovid, ])  */

  const nvoIconLeaflet=(iconUrl, iconAncho)=>{
    const nvo=new leaflet.Icon({
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, 41],
      iconAnchor: [iconAncho??12, 41],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, 41]
    });
    return nvo
  }

  const mostrar=(e)=>{
    //console.log(e);    
  }
 
  return (  
    <div id="map2" ref={mapRef} style={{height:"100%" }}/>  
  );
}